import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'lib-canvas-editor',
  templateUrl: './canvas-editor.component.html',
  styleUrls: ['./canvas-editor.component.scss']
})
export class CanvasEditorComponent implements OnChanges {
  @Input() isLoading = false;
  @Input() imageUrl: string;

  public displayImgUrl: string;
  public imgLoading = false;

  constructor(private _cd: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.imageUrl && changes.imageUrl.currentValue) {
      this.displayImgUrl = changes.imageUrl.currentValue;
    }

    if (changes.isLoading) {
      this.imgLoading = changes.isLoading.currentValue;
    }

    this._cd.detectChanges();
  }
}
